import { render, staticRenderFns } from "./FinancialIcon.vue?vue&type=template&id=1480b3f3&scoped=true&"
var script = {}
import style0 from "./FinancialIcon.vue?vue&type=style&index=0&id=1480b3f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480b3f3",
  null
  
)

export default component.exports